<div class="libero-app-container">
  @if (!translationsLoaded || localDataUpdating) {
    <div class="app-loader-container">
      <libero-preload-spinner></libero-preload-spinner>
    </div>
  } @else if (!showAppContent) {
    <div class="app-loader-container">
      <libero-preload-spinner></libero-preload-spinner>
    </div>
  } @else if (viewBiometricOverlay) {
    <div class="phone-overlay biometry-locked-overlay">
      <svg-icon src="assets/logo/logo.svg" [svgStyle]="{ 'width.px':200 }"></svg-icon>
      <svg-icon
        src="assets/icons/lock.svg"
        [svgStyle]="{ 'width.px':120 }"
      ></svg-icon>
    </div>
  } @else {
    @if (loggedConsult) {
      <libero-header-consult></libero-header-consult>
    }
    <div
      class="libero-content"
      [ngClass]="{ 'libero-content--login': !loggedConsult }"
    >
      <libero-stepper></libero-stepper>
      <router-outlet></router-outlet>
    </div>
    @if (loggedConsult) {
      <libero-consult-footer></libero-consult-footer>
    }
  }
</div>

<libero-modal></libero-modal>
